/**
 * Campo "Valor cuota" de las pantallas que crean o simulan un préstamo.
 *
 * Sin redondeo de cuotas es de solo lectura (la cuota sale del interés). Con
 * varinicial.redondeocuota = 'S' se puede digitar: el interés mensual se
 * recalcula para que dé esa cuota (interesDesdeCuota) y la pantalla lo recibe
 * por onInteres, de modo que lo que viaja al backend sigue siendo la tasa.
 * Mientras se escribe se muestra lo digitado; al salir del campo vuelve a la
 * cuota calculada (una cuota con centavos sube al peso).
 */

import { useState } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { interesDesdeCuota } from "lib/calculocuotas";
import { fmtMoney } from "lib/moneda";

export default function CampoCuota({
  editable,
  cuota, // número calculado o null
  financia,
  plazo,
  formadepago,
  onInteres,
  label = "Valor cuotas",
  helperText,
  helperEdicion = "Digite la cuota; el interés se recalcula",
  valorMostrado, // texto a mostrar fuera de edición (p. ej. cuota con extras)
  siempreTasa = false, // interés siempre % mensual (ver calcularCuotas)
  sx,
  ...rest
}) {
  const [texto, setTexto] = useState(null);
  const [error, setError] = useState("");
  const enEdicion = editable && texto !== null;

  const onChange = (e) => {
    const v = e.target.value;
    setTexto(v);
    if (v === "") {
      setError("");
      return;
    }
    const r = interesDesdeCuota(Number(financia), Number(plazo), formadepago, Number(v), {
      siempreTasa,
    });
    if (r.error) {
      setError(r.error);
      return;
    }
    setError("");
    onInteres(r.interes);
  };

  const mostrado = enEdicion
    ? texto
    : valorMostrado !== undefined
    ? valorMostrado
    : cuota
    ? fmtMoney(cuota)
    : "0.00";

  return (
    <TextField
      fullWidth
      label={label}
      value={mostrado}
      type={enEdicion ? "number" : "text"}
      onFocus={editable ? () => setTexto(cuota ? String(Math.round(cuota)) : "") : undefined}
      onBlur={
        editable
          ? () => {
              setTexto(null);
              setError("");
            }
          : undefined
      }
      onChange={editable ? onChange : undefined}
      error={!!error}
      helperText={
        error ||
        (enEdicion ? helperEdicion : helperText) ||
        (editable ? "Puede digitar la cuota" : undefined)
      }
      sx={sx}
      InputProps={{
        readOnly: !editable,
        startAdornment: <InputAdornment position="start">RD$</InputAdornment>,
      }}
      {...rest}
    />
  );
}
